var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flower-spinner", style: _vm.spinnerStyle }, [
    _c(
      "div",
      { staticClass: "dots-container", style: _vm.dotsContainerStyle },
      [
        _c("div", { staticClass: "big-dot", style: _vm.biggerDotStyle }, [
          _c("div", { staticClass: "small-dot", style: _vm.smallerDotStyle })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }